module.exports = __webpack_public_path__ + "img/IconDesktop.ee30e4b6.svg";